export type LiteralMatchPart = {
  text: string;
  matched: boolean;
};

export function splitLiteralMatches(text: string, rawQuery?: string): LiteralMatchPart[] {
  const query = rawQuery?.trim();
  if (!query) {
    return [{ text, matched: false }];
  }

  const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const matcher = new RegExp(escapedQuery, 'giu');
  const parts: LiteralMatchPart[] = [];
  let cursor = 0;

  for (const match of text.matchAll(matcher)) {
    const start = match.index;
    if (start > cursor) {
      parts.push({ text: text.slice(cursor, start), matched: false });
    }
    parts.push({ text: match[0], matched: true });
    cursor = start + match[0].length;
  }

  if (parts.length === 0) {
    return [{ text, matched: false }];
  }
  if (cursor < text.length) {
    parts.push({ text: text.slice(cursor), matched: false });
  }
  return parts;
}
